import { render, staticRenderFns } from "./SimplePageTitle.vue?vue&type=template&id=6942f626&scoped=true&"
import script from "./SimplePageTitle.vue?vue&type=script&lang=js&"
export * from "./SimplePageTitle.vue?vue&type=script&lang=js&"
import style0 from "./SimplePageTitle.vue?vue&type=style&index=0&id=6942f626&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942f626",
  null
  
)

export default component.exports